<template>
  <div class="partners">

    <!-- [ Header ] start -->
    <!--<Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />-->
    <!-- [ Header ] end -->

    <div class="content">
      <!-- [ Menu ] start -->
      <!--<Menu :open="open" @companyName="companyName"/>-->
      <!-- [ Menu ] end -->

      <div class="wrap">

        <!-- [ Tree ] start -->
        <div class="wrap__tree">

          <div class="nav-tree">
            <!-- <el-button @click="inviteVendor" class="nav-tree__item" size="mini" type="info" round icon="el-icon-plus">Invite Vendor</el-button> -->
            <el-button @click="addVendor" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Vendor</el-button>
            <el-button @click="editVendor" v-show="disabledBtn" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit">Edit Vendor</el-button>
            <el-tooltip effect="dark" content="Delete Vendor" placement="bottom">
              <el-button @click="deleteVendor" v-show="disabledBtn" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-delete"></el-button>
            </el-tooltip>
          </div>

            <ag-grid-vue style="width: 100%; height: 96%;" class="ag-theme-balham" id="myGrid"
              :gridOptions="gridOptions"
              @grid-ready="onGridReady"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowDragManaged="true"
              :animateRows="true"
              :rowData="rowData"
              :rowSelection="rowSelection"
              @selection-changed="onSelectionChanged"></ag-grid-vue>

        </div>
        <!-- [ Tree ] end -->

        <!-- [ Tree info ] start -->
        <div class="wrap__info">

          <!-- [ Info ] start -->
          <div class="wrap__info-tab">
            <el-tabs activeName="info" disabled type="card">
              <el-tab-pane label="Info" name="info">
                <ul v-if="showInfo">
                  <li><strong><span v-html="info.name"></span></strong></li>
                  <li>Location: <span></span></li>
                  <li>Phone: <span v-html="info.phone"></span></li>
                  <li>Fax: <span v-html="info.fax"></span></li>
                  <li>Email: <span v-html="info.email"></span></li>
                  <li>Website: <span v-html="info.website"></span></li>
                  <li>Manual: <span></span></li>
                  <li>Forms: <span></span></li>
                  <li>Spare Parts: <span></span></li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- [ Info ] end -->

          <!-- [ Person ] start -->
          <Person :rowData="rowDataPerson" :disabledBtn="disabledBtnPerson"/>
          <!-- [ Person ] end -->
        </div>
        <!-- [Tree info] end -->

      </div>
    </div>

    <!-- [ Modal form Invite Vendor ] start -->
    <InviteVendor ref="modal"/>
    <!-- [ Modal form Invite Vendor ] end -->

    <!-- [ Modal form Add Vendor ] start -->
    <!-- <AddVendor ref="modal1"/> -->
    <!-- [ Modal form Add Vendor ] end -->

    <!-- [ Modal form Add Vendor Form ] start -->
    <AddVendorForm ref="modal11"/>
    <!-- [ Modal form Add Vendor Form ] end -->

    <!-- [ Modal form Edit Vendor ] start -->
    <!-- <EditVendor ref="modal2"/> -->
    <!-- [ Modal form Edit Vendor ] end -->

    <!-- [ Modal form Edit Vendor ] start -->
    <EditVendorForm ref="modal22" :companyVendorsItem="companyVendorsItem"/>
    <!-- [ Modal form Edit Vendor ] end -->

    <!-- [ Modal are you sure ] start -->
    <sweet-modal blocking ref="confirmation" title="Delete vendor">
        Are you sure you want to delete this vendor?
        <template slot="box-action">
            <a class="button" @click="deleteVendorConfirm">Ok</a> &nbsp;
            <a class="button" @click="$refs.confirmation.close()">Cancel</a>
        </template>
    </sweet-modal>
    <!-- [ Modal are you sure ] end -->
  </div>
</template>

<script>
// import Header from '@/components/Header.vue'
// import Menu from '@/components/Menu.vue'
import InviteVendor from '@/components/vendors/InviteVendor.vue'
// import AddVendor from '@/components/vendors/AddVendor.vue'
import AddVendorForm from '@/components/vendors/AddVendorForm.vue'
// import EditVendor from '@/components/vendors/EditVendor.vue'
import EditVendorForm from '@/components/vendors/EditVendorForm.vue'
import Person from '@/components/vendors/Person.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import {AgGridVue} from "ag-grid-vue"
import axios from 'axios'
export default {
  name: 'partners',
  components: {
    // Header,
    InviteVendor,
    // AddVendor,
    AddVendorForm,
    // EditVendor,
    EditVendorForm,
    AgGridVue,
    SweetModal,

    Person,
    // Menu
  },
  created() {
    this.$store.dispatch('getRowDataVendors')
    // Clear rowDataVendorsPerson
    this.$store.dispatch('getRowDataVendorsPersonClear')
  },
  computed: {
    rowData() {
      return this.$store.getters.getRowDataVendors
    },
    rowDataPerson() {
      return this.$store.getters.getRowDataVendorsPerson
    }
  },
  data() {
    return {
      companyNameSelect: '',

      // open: false,
      disabledBtn: false,
      disabledBtnPerson: true,

      companyVendorsItem: null,

      showInfo: false,
      info: {
        id: '',
        name: '',
        email: '',
        phone: '',
        dateCreated: '',

        fax: '',
        website: '',
      },

      // Tree
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,
    }
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      { field: "id", },
      { field: "name" },
      { field: "email" },
      { field: "phone" },
      { field: "dateCreated" }
    ];
    this.defaultColDef = {
      resizable: true,
      width: 150,
      sortable: true,
      filter: true
    };
    this.rowSelection = "single";
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
  },
  methods: {
    // showMenu() {
    //   this.open = true
    //   console.log('---', this.open);
    // },
    // hideMenu() {
    //   this.open = false
    //   console.log('---', this.open);
    // },
    // companyName(name) {
    //   this.companyNameSelect = name
    // },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    inviteVendor() {
      console.log('---', 'inviteVendor');
      // this.$refs.inviteVendor.open();
      this.$refs['modal'].$refs['inviteVendor'].open()
    },
    addVendor() {
      console.log('---', 'addVendor');
      // this.$refs.addVendor.open();
      // this.$refs['modal1'].$refs['addVendor'].open()
      this.$refs['modal11'].$refs['addVendorForm'].open()
    },
    editVendor() {
      console.log('---', 'editVendor');
      // this.$refs.editVendor.open();
      // this.$refs['modal2'].$refs['editVendor'].open()
      this.$refs['modal22'].$refs['editVendorForm'].open()

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendors/item?companyId=${this.$route.query.companyId}&companyVendorId=${localStorage.getItem('companyVendorId')}`)
        .then(response => {
          console.log('---/companyVendors/item', response.data);
          this.companyVendorsItem = response.data.item
          loader.hide()
        })
        .catch(error => {
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   this.$router.push('/login')
          // }
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    deleteVendorConfirm() {
      console.log('---', 'deleteVendor');
      let selectedRows = this.gridApi.getSelectedRows();
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(` /api/v1/client-vendor/delete?entityType=vendor&id==${selectedRows[0].id}`)
          .then(response => {
              console.log('---', response.data);
              // Clear rowDataVendorsPerson
              // this.$store.dispatch('getRowDataVendorsPersonClear')
              this.showInfo = false

              this.$refs.confirmation.close();
              this.$store.dispatch('getRowDataVendors')
              this.notification("Success", "Delete Vendor", "success");
              loader.hide()
          })
          .catch(error => {
              // if (error.response.data.statusCode == 401) {
              //     localStorage.clear()
              //     this.$router.push('/login')
              // }
              console.log('An error occurred:', error);
              loader.hide()
          });
    },
    deleteVendor() {
      this.$refs.confirmation.open();
    },

    // [ Tree ] start
    onBtSuppressRowDrag() {
      this.gridApi.setSuppressRowDrag(true);
    },
    onBtShowRowDrag() {
      this.gridApi.setSuppressRowDrag(false);
    },
    onGridReady(params) {},
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.disabledBtn = true;
      console.log('---ROW', selectedRows);

      this.info.id = selectedRows[0].id;
      this.info.name = selectedRows[0].name;
      this.info.email = selectedRows[0].email;
      this.info.phone = selectedRows[0].phone;
      this.info.dateCreated = selectedRows[0].dateCreated;

      this.info.fax = selectedRows[0].fax;
      this.info.website = selectedRows[0].website;
      // this.info.work_phone = selectedRows[0].work_phone;
      // this.info.home_phone = selectedRows[0].home_phone;
      // this.info.phone = selectedRows[0].phone;
      // this.info.company = selectedRows[0].company;
      // this.info.avatarUrl = selectedRows[0].avatarUrl;

      localStorage.setItem('companyVendorId', selectedRows[0].id)
      // this.$store.dispatch('getRowDataVendorsPerson');
      this.disabledBtnPerson = false

      this.showInfo = true;
    },
    // [ Tree ] end
  },
}
</script>

<style lang="scss" scoped>
.partners {
  background: #f2f4f7;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__tree {
    width: 35%;
    padding: 0 10px 10px 0;
    border-right: 1px solid #ccc;
  }
  &__info {
    display: flex;
    flex-direction: column;
    width: 65%;
    padding: 0 0 10px 10px;
  }
  &__info-tab {
    height: 50%;
    overflow-y: auto;
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        margin-bottom: 8px;
        // span {
        //   font-weight: 500;
        //   color: #909399;
        // }
      }
    }
  }
  &__person {
    height: 50%;
  }
}
// [ Wrapper ] end

// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>

